"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeStyles = exports.setStyles = void 0;
var is_number_1 = require("./is-number");
var safe_element_1 = require("./safe-element");
function stylePropCamelCase(str) {
    return str.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}
function setStyles(selector, styles) {
    Object.keys(styles).forEach(function (prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if (['width', 'height', 'top', 'right', 'bottom', 'left', 'min-width', 'max-width', 'max-height', 'min-height']
            .indexOf(prop) !== -1 && is_number_1.isNumber(styles[prop])) {
            unit = 'px';
        }
        safe_element_1.safeElements(selector).forEach(function (element) {
            element.style[stylePropCamelCase(prop)] = styles[prop] + unit;
        });
    });
}
exports.setStyles = setStyles;
function removeStyles(selector) {
    var styles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styles[_i - 1] = arguments[_i];
    }
    styles.forEach(function (prop) {
        safe_element_1.safeElements(selector).forEach(function (element) {
            element.style[stylePropCamelCase(prop)] = null;
        });
    });
}
exports.removeStyles = removeStyles;
//# sourceMappingURL=set-styles.js.map